import createClient from '@economic/http-client';
import { INTERNAL_API_APP_TOKEN_URL } from './internalApiClient';

export default createClient(process.env.ECONOMIC_REST_PATH, INTERNAL_API_APP_TOKEN_URL);
